import {colorPastelBlue} from "../../shared/colors";
import {CategoryId, Lesson, LessonId} from "./types";
import {ScenarioFragment} from "./scenario/ScenarioFragment";

export const LESSONS: Lesson[] = [
  {
    id: LessonId.SCENARIO_ORDERING_COFFEE,
    categoryId: CategoryId.SCENARIOS,
    text: "Working through a scenario. Ordering coffee",
    titleLines: ["Ordering", "Coffee"],
    background: colorPastelBlue,
    renderClass: ScenarioFragment,
  },
];